
import BusinessLogo from "@/components/business/BusinessLogo"
import SubscriptionMenu from "@/components/admin/business/SubscriptionMenu"

export default {
    name: "BusinessHeader",
    components: {
        SubscriptionMenu,
        BusinessLogo,
    },
    props: {
        business: {
            default: null,
            type: Object,
        },
    },
    computed: {
        logo() {
            return this.$getImage({
                image: this.business.logo,
                preferedSize: "3",
            })
        },
        displayedAddress() {
            const address = this.business.primary_address
            if (!address) return ""
            return `${address.street}, <strong>${address.postal_code} ${address.city}</strong>`
        },
    },
}
